<template>
	<!-- Content -->
	<div :class="{ 'opacity-50': status == 'feedback' }">

		<!-- Question -->
		<div class="m-auto" style="max-width: 700px;">
			<span class="h5" v-html="questionText"></span>
			<hr>
		</div>

		<!-- Radio buttons -->
		<div class="d-flex mt-4 justify-content-center">
			<div v-for="(group, index) in boxes" :key="index" class="d-flex flex-wrap blockquote" :class="{ 'ps-4': index > 0, 'pe-4': index < boxes.length-1, 'border-end': index < boxes.length-1 }">

				<table class="table borderless">
					<tbody>
						<tr v-for="box in group" :key="box.index" class="form-check text-start">
							<td style="border: none;">
								<input v-model="answers[index]" type="radio" role="button"
								:id="box.index" :value="box" :name="'group'+index" :disabled="lockInput"
								class="form-check-input" style="margin-right: 0.5em;"
								:class="{
									'checkbox-correct': box.styleCorrect,
									'checkbox-incorrect': box.styleIncorrect
								}">
								<label :for="box.index" role="button"
								class="form-check-label no-select"
								:class="{
									'label-correct': answers[index] == box && box.styleCorrect,
									'label-incorrect': answers[index] == box && box.styleIncorrect
								}">
									{{ getAnswerText(box.index) }}
								</label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Button and hint area -->
		<div v-if="status != 'feedback'" class="mt-4">
			<div class="m-auto" style="max-width: 700px;">
				<hr>
			</div>

			<!-- Help text -->
			<div class="mb-3">
				<div v-if="status == 'verify'" class="text-muted">
					<span>
						{{ $t('quiz_hint_blanks') }}
					</span>
				</div>
				<div v-if="status == 'try-again'" class="text-danger">
					<span>
						{{ $t('quiz_try_again') }}
					</span>
				</div>
				<div v-if="status == 'success'" class="text-success">
					<span>
						{{ $t('quiz_correct') }}
					</span>
				</div>
			</div>

			<!-- Answer button -->
			<div v-if="status == 'verify'">
				<button
					class="btn px-5 progress-bar-striped"
					:class="{ 'btn-primary': allowSubmit, 'btn-secondary': !allowSubmit, 'progress-bar-animated': allowSubmit }"
					@click="verify"
					:disabled="!allowSubmit">
					{{ $t('quiz_button_verify') }}
				</button>
			</div>
			<div v-else-if="status == 'try-again'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-danger"
					@click="tryAgain">
					{{ $t('quiz_button_try_again') }}
				</button>
			</div>
			<div v-else-if="status == 'success'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-success"
					@click="complete">
					{{ $t('continue') }}
				</button>
			</div>
		</div>
	</div>
</template>



<script>
import Timer from '@/components/Timer';

export default {
	props: [ "question", "selectedIndex" ],
	components: {},
	data() {
		return {
			id: null,
			status: null,
			lockInput: false,
			boxes: [],
			answers: [],
			answerIds: [],
			blankLengths: [],

			timer: null,
		};
	},
	methods: {
		load(question) {
			this.id = question.id;
			// question.difficulty
			this.status = 'verify';
			this.lockInput = false;

			this.boxes = [];
			this.answers = [];
			this.answerIds = question.answerIds;

			for (let i = 0; i < question.answers.length; i++) {
				const group = question.answers[i];
				this.boxes.push([]);
				this.answers.push(null);

				for (let j = 0; j < group.length; j++) {

					this.boxes[i].push({
						index: group[j],
						isCorrect: question.correct.includes(group[j]),
						styleCorrect: false,
						styleIncorrect: false,
					});

				}
			}

			if (question.shuffle) {
				for (let group of this.boxes) {
					this.shuffle(group);
				}
			}

			this.updateBlankLengths();

			// Log new question
			if (!this.$tracker.isTaskComplete(this.id)) {
				const currentOrder = this.boxes.map(
					group => group.map(
						box => box.index
					)
				);
				this.$log.onQuestionStart(this.id, question.mechanic, this.selectedIndex+1, currentOrder, question.correct);
				this.$tracker.onTaskStart(this.id);
			}
			// Auto-complete answers
			else {
				this.verify(null, true);
			}
		},
		// updateQuestionText() {
		// 	this.questionSegments = [];
		// 	this.questionSegments = this.questionText.split(/_+/);
		// },
		verify(event, autoComplete=false) {
			if (autoComplete) {
				this.answers = this.boxes.map(group => group.find(box => box.isCorrect));
			}

			let allCorrect = true;
			for (let box of this.answers) {
				box.styleCorrect = (box.isCorrect);
				box.styleIncorrect = (!box.isCorrect);

				if (!box.isCorrect) {
					allCorrect = false;
				}
			}

			if (autoComplete) {
				this.status = 'feedback';
				this.lockInput = true;
			}
			else {
				this.$log.onQuestionVerify(this.id, this.currentAnswers, allCorrect);
				if (allCorrect) {
					this.status = 'success';
					this.$emit("complete");
					this.$log.onQuestionComplete(this.id);
					this.$tracker.onTaskComplete(this.id, this.timer.elapsed);
					this.lockInput = true;
				}
				else {
					this.status = 'try-again';
					// this.lockInput = true;
					this.$tracker.onTaskMistake();
				}
			}
		},
		complete() {
			this.status = 'feedback';
			this.$emit("progress");
			this.$log.onQuestionNext(this.id);
		},
		tryAgain(reset=true) {
			this.status = 'verify';
			this.lockInput = false;
			this.$log.onQuestionTryAgain(this.id);

			for (let i = 0; i < this.boxes.length; i++) {
				if (reset) this.$set(this.answers, i, null);
				for (let box of this.boxes[i]) {
					box.styleCorrect = false;
					box.styleIncorrect = false;
				}
			}
		},
		getAnswerText(index) {
			if (this.answerIds[index-1])
				return this.getText(this.answerIds[index-1]);
			return "";
			// return this.getText(this.boxes[index-1].key);
			// return this.getText(this.question.id, 'answer_' + index);
		},
		updateBlankLengths() {
			this.blankLengths = [];
			for (let i = 0; i < this.boxes.length; i++) {
				const lengths = this.boxes[i].map(box => this.getAnswerText(box.index).length);
				const average = (array) => array.reduce((a, b) => a + b) / array.length;
				const count = Math.min(15, average(lengths) + 1);
				const text = '_'.repeat(count);
				this.blankLengths.push(text);
			}
		}
	},
	computed: {
		allowSubmit() {
			return this.answers.every(answer => answer != null);
		},
		originalQuestion() {
			return this.getText(this.question.id, 'text');
		},
		questionText() {
			let segments = this.originalQuestion.split(/_+/);
			let text = '';
			for (let i = 0; i < segments.length; i++) {

				// Add part of question text
				text += segments[i];

				if (i < this.answers.length) {
					if (this.answers[i]) {
						// Add answer with underscore
						text += `<u class="text-primary">${this.getAnswerText(this.answers[i].index).toLowerCase()}</u>`;
					}
					else {
						// Add blank space
						text += `<span class="text-primary">${this.blankLengths[i]}</span>`;
					}

				}
			}
			return text;
		},
		currentAnswers() {
			return this.answers.map(group => {
				return group ? group.index : -1;
			});
		}
	},
	watch: {
		question(newData) {
			this.load(newData);
		},
		originalQuestion() {
			this.updateBlankLengths();
		},
		currentAnswers() {
			if (this.status == 'try-again') {
				this.tryAgain(false);
			}
			this.$log.onQuestionChangeAnswer(this.id, this.currentAnswers);
		}
	},
	mounted() {
		this.timer = new Timer();
		this.load(this.question);
	},
	beforeDestroy() {
		if (this.timer) {
			this.timer.clear();
		}
	}
};
</script>



<style scoped>
</style>
